import React, { /*useEffect*/ } from 'react'
import { GraniteDataGrid } from '@tecuity/granite-ui/GraniteDataGrid';
import { shallowEqual, useDispatch, useSelector } from 'react-redux';
import { SET_SELECTED_BATCHES } from '../../Reconcile/ReconcileReducer';

const SelectBatches = () => {
  const dispatch = useDispatch();
  const { batches = [], selectedBatches, /*batchInfo*/ } = useSelector(state => state.reconcile, shallowEqual);

  // useEffect(() => {
  //   console.log('batches', batches)
  // }, [batches])

  const selectBatchesColumns = [
    { "field": "Desc", "flex": 0.75, "minWidth": 60, "headerName": "Batch Type", "disableColumnMenu": true },
    { "field": "Count", "flex": 0.75, "minWidth": 60, "headerName": "Count", "disableColumnMenu": true },
    {
      "field": "Amount", "flex": 0.75, "minWidth": 60, "headerName": "Amount", "disableColumnMenu": true,
      renderCell: (params) => {
        return `$${(params.row.Amount || 0).toFixed(2).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')}`
      }
    },
  ]

  const selectBatchesColumns_AmountDisabled = [
    { "field": "Desc", "flex": 0.8, "minWidth": 60, "headerName": "Batch Type", "disableColumnMenu": true },
    { "field": "Count", "flex": 0.2, "minWidth": 60, "headerName": "Count", "disableColumnMenu": true },
  ]

  return (
    <div className='accounting-table'>
      <GraniteDataGrid
        columns={
          batches.length > 0 && batches[0].Amount != null
            ? selectBatchesColumns
            : selectBatchesColumns_AmountDisabled
        }
        rows={batches}
        pagination={undefined}
        rowsPerPageOptions={[25, 50, 100]}
        checkboxSelection={true}
        selectionModel={selectedBatches}
        onSelectionModelChange={(ids) => {
          dispatch({ type: SET_SELECTED_BATCHES, selectedBatches: ids })
        }}
      />
    </div>
  )
}

export default SelectBatches 